import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function WhatsAppButton() {
  const href = `https://wa.me/${COMPANY.whatsappRaw}?text=${encodeURIComponent(
    "Halo AJE, saya tertarik dengan solusi panel surya. Boleh minta info lebih lanjut?"
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 rounded-full bg-emerald-500 pl-4 pr-5 py-3 text-white shadow-2xl shadow-emerald-500/40 aje-pulse transition-transform duration-200 hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="hidden sm:inline font-semibold text-sm">Chat via WhatsApp</span>
    </a>
  );
}
